import { frontendURL } from 'dashboard/helper/URLHelper';

const CabosEleitoraisIndex = () => import('./pages/CabosEleitoraisIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/cabos-eleitorais'),
      name: 'cabos_eleitorais_index',
      component: CabosEleitoraisIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
